import script from "./HtmlConstructorBlock.vue?vue&type=script&lang=ts&setup=true"
export * from "./HtmlConstructorBlock.vue?vue&type=script&lang=ts&setup=true"

import "./HtmlConstructorBlock.vue?vue&type=style&index=0&id=04f5e1bb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04f5e1bb"]])

export default __exports__